import { LogOut } from 'lucide-react';
import type { JSX } from 'react';
import { signOut } from '../auth';
import { AuthScreen } from '@/components/auth-screen';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

export function ForbiddenPage(): JSX.Element {
  return (
    <AuthScreen>
      <Card>
        <CardContent className="grid gap-4 p-6">
          <div className="grid gap-1">
            <p className="m-0 font-mono text-caption text-muted-foreground">Erreur 403</p>
            <h1 className="m-0 text-title">Accès refusé</h1>
            <p className="m-0 text-small text-muted-foreground">
              Votre compte n&apos;est pas autorisé à accéder au dashboard opérateur.
            </p>
          </div>
          <Button
            type="button"
            variant="outline"
            size="lg"
            className="w-full"
            onClick={() => void signOut()}
          >
            <LogOut aria-hidden="true" />
            Se déconnecter
          </Button>
        </CardContent>
      </Card>
    </AuthScreen>
  );
}
